import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientDetailPage from "@/pages/admin/ClientDetailPage";

export const Route = createFileRoute("/_admin/admin/clients/$id")({
  head: () => pageHead("Client profile", "AKIVA admin: client details, points of contact, contracts and portal accounts.", "/admin/clients/$id", true),
  component: ClientDetailPage,
});
